// src/components/views/BusinessLicensesView.js
import React from 'react';
import { ArrowLeft, CreditCard } from 'lucide-react';

const BusinessLicensesView = ({ 
  business, 
  onBack, 
  businessLicenses, 
  systems, 
  allLicensesLoading, 
  onPaymentClick 
}) => {
  return (
    <div>
      <div className="mb-6">
        <button 
          onClick={onBack}
          className="text-blue-600 hover:text-blue-800 mb-4 flex items-center space-x-2"
        >
          <ArrowLeft size={20} />
          <span>Back to Business Collection</span>
        </button>
        <div>
          <h1 className="text-2xl font-bold text-gray-800">
            Licenses for {business?.business_name || 'Business'}
          </h1>
          <p className="text-gray-600">View all licenses for this business</p>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow overflow-hidden">
        <div className="overflow-x-auto">
          <table className="min-w-full">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">LICENSE ID</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">SYSTEM</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">LICENSE KEY</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">ISSUE DATE</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">EXPIRY DATE</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">SUBSCRIPTION TYPE</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">MAX USERS</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">STATUS</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">ACTION</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {allLicensesLoading ? (
                <tr>
                  <td colSpan="9" className="px-6 py-8 text-center text-gray-500">
                    Loading licenses...
                  </td>
                </tr>
              ) : businessLicenses.length > 0 ? (
                businessLicenses.map((license, index) => {
                  const system = systems.find(s => s.system_id === license.system_id);
                  return (
                    <tr key={index} className="hover:bg-gray-50">
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{license.license_id || 'Not available'}</td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{system?.system_name || 'Unknown System'}</td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 font-mono">{license.license_key || 'Not available'}</td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{license.issue_date || new Date().toISOString().split('T')[0]}</td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{license.expiry_date || new Date().toISOString().split('T')[0]}</td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                          license.subscription_type === 'yearly' ? 'bg-purple-100 text-purple-800' : 'bg-blue-100 text-blue-800'
                        }`}>
                          {license.subscription_type || 'yearly'}
                        </span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{license.max_users || 1}</td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <span className={`px-3 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${
                          license.status === 'Active' ? 'bg-green-100 text-green-800' : 
                          license.status === 'Inactive' ? 'bg-red-100 text-red-800' : 
                          'bg-yellow-100 text-yellow-800'
                        }`}>
                          {license.status || 'Active'}
                        </span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm">
                        <button 
                          onClick={() => onPaymentClick(license)}
                          className="text-green-600 hover:text-green-900 font-medium text-xs flex items-center space-x-1 bg-green-50 hover:bg-green-100 px-3 py-1 rounded transition-colors"
                        >
                          <CreditCard size={14} />
                          <span>Payment</span>
                        </button>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="9" className="px-6 py-8 text-center text-gray-500">
                    No licenses found for this business
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default BusinessLicensesView;